export default __webpack_public_path__ + "static/media/pizza.f3c2131b.png";